<template>
  <div class="login-page">
    <div class="login-card">
      <div class="logo-group">
        <div class="logo-circle">
          <img :src="config.silte_logo" alt="">
        </div>
<!--        <span class="logo-name">{{config.site_name}}</span>-->
      </div>

      <!-- 标题 -->
      <div class="title-group">
        <h2>登录</h2>
        <p>输入您的账号密码登录</p>
      </div>

      <!-- 表单 -->
      <el-form ref="loginForm" :model="form" :rules="rules" class="login-form">
        <!-- 用户名 -->
        <el-form-item label="用户名" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入您的用户名"></el-input>
        </el-form-item>

        <!-- 密码 -->
        <el-form-item label="密码" prop="password">
          <el-input v-model="form.password" type="password" placeholder="请输入密码" show-password></el-input>
        </el-form-item>

        <!-- 记住密码 + 忘记密码 -->
        <div class="form-option">
          <el-checkbox v-model="form.remember">记住密码</el-checkbox>
          <!--          <span class="forget-txt">忘记密码？<a>点击联系客服</a></span>-->
        </div>

        <!-- 登录按钮 -->
        <el-button type="primary" class="login-btn" @click="submit">登录</el-button>
      </el-form>
    </div>
    <!-- 版权-->
    <div class="copyright">
      <div class="mr"> {{config.beian}}</div>
      <div class="mr"><a href="https://beian.miit.gov.cn/" target="_blank">{{config.miitbeian}}</a></div>
      <div>{{config.site_copy}}</div>
    </div>
  </div>
</template>

<script>
  import {getBaseCofig} from '@/api/api'

  export default {
    name: "Login",
    data() {
      return {
        form: {
          phone: "",
          password: "",
          remember: false,
        },
        rules: {
          phone: [{required: true, message: "请输入用户名", trigger: "blur"}],
          password: [{required: true, message: "请输入密码", trigger: "blur"}]
        },
        config: {}
      };
    },
    created() {
      // 页面加载时，检查是否有记住的密码
      this.getRememberedUser()
      this.getBaseCofig()
    },
    methods: {
      // 获取记住的账号密码
      getRememberedUser() {
        const remembered = localStorage.getItem('remembered_user')
        if (remembered) {
          try {
            const userInfo = JSON.parse(remembered)
            this.form.phone = userInfo.phone || ''
            this.form.password = userInfo.password || ''
            this.form.remember = true
          } catch (e) {
            console.error('解析记住的密码失败', e)
          }
        }
      },
      // 获取系统配置
      getBaseCofig() {
        getBaseCofig().then(res => {
          this.config = res.data
        })
      },
      submit() {
        this.$refs.loginForm.validate(valid => {
          if (valid) this.$store.dispatch('login', this.form)
        });
      }
    }
  };
</script>

<style lang="less" scoped>
  .login-page {
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* 核心盒子：和你图片完全一样的宽高、内边距 */
  .login-card {
    width: 410px;
    background: #fff;
    border-radius: 8px;
    padding: 44px 40px;
    box-shadow: 0 1px 12px rgba(0, 0, 0, 0.05);
    box-sizing: border-box;
  }

  /* LOGO */
  .logo-group {
    display: flex;
    align-items: center;
    justify-content: center; /* 整体居中 */
    margin-bottom: 22px;
    gap: 8px;

    /* 外层圆形 */

    .logo-circle {
      width: 120px;
      height: 120px;
      /*background-color: #4a3ff0;*/
      /*border-radius: 50%; !* 纯CSS圆形！ *!*/
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        /*border-radius: 50%;*/
      }
    }

    /* Logo文字紫色 */

    .logo-name {
      font-size: 18px;
      font-weight: 500;
      color: #4a3ff0;
    }
  }


  /* 标题 */
  .title-group {
    text-align: left;
    margin-bottom: 28px;

    h2 {
      font-size: 22px;
      color: #222;
      margin: 0 0 6px 0;
      font-weight: 500;
    }

    p {
      font-size: 14px;
      color: #666;
      margin: 0;
    }
  }

  /* 表单布局 */
  .login-form {
    width: 100%;
  }

  /* 记住密码 + 忘记密码 */
  .form-option {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 0 24px 0;
    font-size: 14px;

    .forget-txt {
      color: #666;

      a {
        color: #4A3FF0;
        cursor: pointer;
      }
    }
  }

  /* 按钮：只改颜色，不改样式 */
  .login-btn {
    width: 100%;
    height: 40px;
    font-size: 16px;
    background-color: #4A3FF0 !important;
    border: none !important;
  }


  .copyright {
    position: fixed;
    bottom: 20px;
    margin-top: 30px;
    color: #7e007e;
    font-size: 14px;
    display: flex;
    align-items: center;

    a {
      text-decoration: none;
    }

    .mr {
      margin-right: 20px;
    }
  }
</style>
